import { RemoteChangePersonCpf } from 'data/usecases';
import { makeApiUrlAdminPeople } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteChangePersonCpf = (): RemoteChangePersonCpf => {
  return new RemoteChangePersonCpf(
    makeApiUrlAdminPeople(),
    makeAxiosHttpClient(),
  );
};
